# frozen_string_literal: true

module Engine
  module Game
    module G1830
    end
  end
end
